// extracted by mini-css-extract-plugin
module.exports = {"container":"toggle-button-add-remove_container__3DyP5"};